import React from 'preact/compat';
import { h } from 'preact';
import { useState } from 'preact/hooks';
import DataManagerService from '../service/DataManagerService';

export function PopMenuImport(props) {
  const [path, setPath] = useState("www.mistaquitos.nyc/menu");
  const [importing, setImporting] = useState(false);

  async function fetch() {
    setImporting(true);
    const resp = await DataManagerService.getPopMenuItems(path);
    props.onSuccess([
      {
        source: `Imported from ${path}`,
        name: "Menu",
        sections: await resp.json()
      }
    ], path);
    setImporting(false);
  }

  return <div className={"pop-menu"}>
    <input type="text" value={path} placeholder={"www..."} onChange={ev => setPath(ev.target.value)}/>
    <button className={'btn primary'} onClick={fetch}>
      {importing ? "Importing..." : "Import"}
    </button>
  </div>;
}
